import JsonApi from 'devour-client'
import axios from 'axios'
import models from './models'

export function createApiClient (pluginsUrl, token) {
  const options = {
    apiUrl: pluginsUrl
  }
  if (token) {
    options.bearer = token
  }
  const api = new JsonApi(options)
  api.axios = axios
  models.forEach((m) => api.define(m.name, m.definition, m.options))
  return api
}
